<script>
export default {
  props: {
    module: Object,
  },
  methods: {
    handlerSubmit() {
      this.module.resolve();
    },
    handlerClose() {
      this.module.reject();
    },
  },
};
</script>
<template>
  <v-dialog
    :value="module.show"
    max-width="420px"
    persistent
  >
    <v-card v-if="module.show">
      <v-card-title>
        <span class="headline">{{ module.title }}</span>
      </v-card-title>
      <v-card-text>
        <v-container v-html="module.message">
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="handlerClose"
        >
          {{ module.close }}
        </v-btn>
        <v-btn
          color="primary"
          @click="handlerSubmit"
        >
          {{ module.accept }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<style lang="scss">
</style>
